import { NavigateOptions, useSearchParams } from "react-router-dom";

type SetURLSearchParams = ReturnType<typeof useSearchParams>[1];

function updateURLSearchParam(body: {
  toUpdate: URLSearchParams;
  key: string;
  value?: string | null | string[];
}): URLSearchParams {
  const { toUpdate, key, value } = body;
  if (value) {
    if (Array.isArray(value)) {
      toUpdate.delete(key);
      value.forEach((v) => toUpdate.append(key, v));
    } else {
      toUpdate.set(key, value);
    }
  } else {
    toUpdate.delete(key);
  }
  return toUpdate;
}

export default function useSearchParamsWithUpdate(): {
  searchParams: URLSearchParams;
  setSearchParams: SetURLSearchParams;
  updateParam: (key: string, value?: string | null | string[], options?: NavigateOptions) => URLSearchParams;
  updateParams: (
    params: { key: string; value?: string | null | string[] }[],
    options?: NavigateOptions
  ) => URLSearchParams;
} {
  const [searchParams, setSearchParams] = useSearchParams();
  const updateParam = (key: string, value?: string | null | string[], options?: NavigateOptions) => {
    const toUpdate = new URLSearchParams(searchParams.toString());
    updateURLSearchParam({ toUpdate, key, value });
    setSearchParams(toUpdate, options);
    return toUpdate;
  };
  const updateParams = (params: { key: string; value?: string | null | string[] }[], options?: NavigateOptions) => {
    const toUpdate = new URLSearchParams(searchParams.toString());
    params.forEach(({ key, value }) => updateURLSearchParam({ toUpdate, key, value }));
    setSearchParams(toUpdate, options);
    return toUpdate;
  };

  return {
    searchParams,
    setSearchParams,
    updateParam,
    updateParams,
  };
}
